import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../../../core/modules/shared.module';

import { FuseSampleComponent } from './sample.component';
import { AuthGuard } from '../../../_guards/auth.guard';
import { RoleGuard } from '../../../_guards/role.guard';
import { FuseWidgetModule } from '../../../core/components/widget/widget.module';

const routes = [
    {
        path     : 'dashboard',
        component: FuseSampleComponent,
        data :{
            permission:{
                only :['role1','role2']
            }
        },
        canActivate:[AuthGuard,RoleGuard]
    }
];

@NgModule({
    declarations: [
        FuseSampleComponent
    ],
    imports     : [
        SharedModule,
        RouterModule.forChild(routes),
        FuseWidgetModule
    ],
    exports     : [
        FuseSampleComponent
    ],
    providers :[
        AuthGuard,RoleGuard
    ]
})

export class FuseSampleModule
{
}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadviceadminSkeleton/src/app/main/content/sample/sample.module.ts